export const getElementArrayByAttribute = (
  attribute: string
): [HTMLElement] => {
  try {
    const divArray = (document.querySelectorAll(`${attribute}`) as unknown) as [
      HTMLElement
    ];

    return divArray;
  } catch (error) {
    throw error;
  }
};
